<template>
  <div class="UXtagInp">
    <v-text-field
      ref="tagInp"
      class="tag-input"
      v-model="tagInput"
      placeholder="タグ入力"
      color="6D8DFF"
      :append-icon="tagInput && tagInput.length ? 'close': 'edit'"
      @input="resize"
      @keydown.enter.exact.prevent
      @keyup.enter.exact="sendTag()"
      @click:append="tagInput && tagInput.length ? removeTaginp() : sendTag()"
      hide-details
      outline
      solo
      maxLength="100"
    ></v-text-field>
    <div ref="tagHideTxt" class="hideTagText">{{tagInput}}</div>
    <p v-for="(item, index) in localTags" :key="index" class="UXtagItem">{{item}} <i class="UXicon-close" @click="deleteTag(item)"></i></p>
  </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex'

export default {
  name: 'ticket_tag_list',
  props: ['ticketId', 'tags', 'brandId'],
  data () {
    return {
      tag: null,
      color: '#fdf09e',
      localTags: [],
      isBackPress: false,
      tagInput: ''
    }
  },
  computed: {
    ...mapGetters([
      'currentTicketBrandId',
      'currentTicketBrandName'
    ]),
    ...mapState([
      'currentTicketBrandId '
    ])
  },
  created () {
    this.initTags(this.tags)
  },
  methods: {
    deleteTag (tag) {
      this.localTags.splice(this.localTags.indexOf(tag), 1)
    },
    sendTag () {
      let inputValue = this.tagInput.replace(/ /g, '')
      if (inputValue && this.localTags.indexOf(inputValue) === -1) {
        this.localTags.push(inputValue)
        this.removeTaginp()
      }
    },
    removeTaginp () {
      this.tagInput = ''
      this.resize()
    },
    // 간헐적으로 tags가 [] 로 넘어와 watch 에서 처리.
    // tags (newVal, oldVal) {
    //   this.initTags(newVal)
    // },
    resize () {
      setTimeout(() => {
        this.$refs.tagInp.$el.style.width = (this.$refs.tagHideTxt.offsetWidth + 60) + 'px'
      })
    },
    keyUpEvent (event) {
      // 'backPress'
      if (event && event.keyCode === 8) {
        this.isBackPress = true
        return
      }
      this.isBackPress = false
    },
    initTags (tags) {
      if (tags) {
        this.clearLocalTags()
        tags.forEach(tag => {
          this.localTags.push(tag)
        })
      }
    },
    clearLocalTags () {
      this.localTags = []
    },
    filter (item, queryText, itemText) {
      if (item.header) return false

      const hasValue = val => val != null ? val : ''

      const text = hasValue(itemText)
      const query = hasValue(queryText)

      return text.toString()
        .toLowerCase()
        .indexOf(query.toString().toLowerCase()) > -1
    },
    createTag (text) {
      if (text.trim().length === 0) return
      this.axios.post('/gateway/ticket/tag',
        {
          text: text.trim(),
          brandId: this.currentTicketBrandId
        })
        .then(res => {
          if (res.data.code === 0) {
            const data = res.data.data
            this.addTag(data)
          }
        })
    },
    addTag (data) {
      let item = {id: data.id, text: data.text, color: this.color}

      let exist = this.localTags.filter(t => t.id === item.id)
      if (exist.length === 0) {
        this.localTags.push(item)
        if (this.ticketId) {
          this.axios.post(`/gateway/ticket/${this.ticketId}/tags`, {
            tagInfo: {
              id: data.id,
              brandId: this.currentTicketBrandId
            }
          }).then(res => {})
        }
      }
    },
    removeTag (tag) {
      // 내부 array 제거.
      this.localTags.forEach((t, index) => {
        if (typeof t === 'object') {
          if (t.id === tag.id) {
            this.localTags.splice(index, 1)
          }
        } else if (typeof t === 'string') {
          this.localTags.splice(index, 1)
        }
      })
      // 티켓 ID 가 존재할 경우 remove 호출. (상세 페이지에서 실시간 적용)
      if (this.ticketId) {
        this.axios.delete(`/gateway/ticket/${this.ticketId}/tags`, {
          tagInfo: {
            id: tag.id,
            brandId: this.currentTicketBrandId
          }
        }).then(res => {})
      }
    }
  }
}
</script>

<style scoped>
  .v-list--two-line .v-list__tile{
    height: auto !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/menus/ticket/component/ticket_tag_list.vue